// Renders the real RemboList brand mark (public/rembo_logo.png) instead of
// a hand-drawn SVG approximation of it.

export default function RemboMark({
  size = 48,
  variant, // eslint-disable-line no-unused-vars -- kept so call sites don't need to change; raster mark can't be recolored
  className,
  title,
  ...rest
}) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/rembo_logo.png`}
      alt={title || ""}
      aria-hidden={title ? undefined : true}
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size, objectFit: "contain" }}
      {...rest}
    />
  );
}
